
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'YellowBg',
  mixins: [staticBlockMixin],
  props: {
    imageRight: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
